module.exports = __webpack_public_path__ + "static/media/Logo.811efe2f.png";